import { kebabCase } from 'lodash';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useHonorificBlockTimeItems } from './use-honorific-block-time-items';

// honorific block time values for templates
export const useHonorificTemplateBlockTimeValues = (
  healthProviderId: string | null | undefined,
  skip?: boolean
) => {
  const intl = useIntl();
  const { data: result, loading } = useHonorificBlockTimeItems(
    { healthProviderId },
    skip
  );

  const data = useMemo(
    () =>
      result?.map(option => ({
        key: option.honorific,
        title: intl.formatMessage({
          id: `common.honorific.${kebabCase(option.honorific)}`,
        }),
        value: option.blockMinutes,
      })),
    [result, intl]
  );

  return {
    data,
    loading,
  };
};
